import React from 'react';
import { Row, Col } from 'react-bootstrap';

import MaintenanceOrderEditContainer from '../containers/MaintenanceOrderEditContainer.jsx';
import MaintenanceOrderDetailEditContainer from '../containers/MaintenanceOrderDetailEditContainer.jsx';

const MaintenanceOrderFlowEditComponent = ({
    // state
    step1Class,
    step2Class,
    step1Display,
    step2Display
    // dispatch
}) => (

        <div>
            <Row style={{ marginLeft: 15, marginRight: 15 }}>
                <Col xs={12} sm={12} md={12}>
                    <ul className="nav nav-pills nav-justified thumbnail setup-panel">
                        <li className={step1Class}><a href="#step-1">
                            <p className="list-group-item-heading" style={{ fontSize: 25 }}>1.新增訂單內容</p>
                        </a></li>
                        <li className={step2Class}><a href="#step-2">
                            <p className="list-group-item-heading" style={{ fontSize: 25 }}>2.新增訂單明細</p>
                        </a></li>
                    </ul>
                </Col>
            </Row>
            <Row>
                <Col xs={12} sm={12} md={12}>
                    <div id="addOrder" style={{ display: step1Display }}>
                        <MaintenanceOrderEditContainer />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} sm={12} md={12}>
                    <div id="addOrderDetails" style={{ display: step2Display }}>
                        <MaintenanceOrderDetailEditContainer />
                    </div>
                </Col>
            </Row>
        </div>

    );

export default MaintenanceOrderFlowEditComponent;


// WEBPACK FOOTER //
// ./src/components/MaintenanceOrderFlowEditComponent.jsx